<template>
  <div class="vue__checkbox-wrapper">
    <input
      :id="$attrs.name"
      type="checkbox"
      :checked="value"
      v-bind="$attrs"
      class="vue__checkbox-input"
      v-on="listeners"
    />

    <label
      class="vue__checkbox-label"
      :class="{ 'has-error': validated && error }"
      :for="$attrs.name"
    >

      <slot></slot>

    </label>
    <ErrorWrapper v-if="validated && error">
      {{error}}
    </ErrorWrapper>
  </div>
</template>

<script>
  export default {
    inheritAttrs: false,

    props: {
      value: {
        type: Boolean,
        required: true,
      },

      validated: {
        type: Boolean,
        default: false,
      },

      error: {
        type: String,
        default: '',
      },
    },

    computed: {
      listeners () {
        return {
          ...this.$listeners,
          input: event => this.$emit('input', event.target.checked),
          change: event => this.$emit('input', event.target.checked),
        };
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .vue__checkbox-wrapper {
    margin-bottom: 6px;
  }
  //Styled checkboxes
  .vue__checkbox-input {
    position: absolute; // take it out of document flow
    opacity: 0; // hide it

    & + label {
      position: relative;
      cursor: pointer;
      padding: 0;
      font-weight: 400 !important;

      user-select: none;

      &.has-error {
        border-color: #ff5d33 !important;
        outline: none;
      }
    }

    // Box.
    & + label:before {
      box-sizing: border-box;
      content: '';
      margin-right: 6px;
      display: inline-block;
      vertical-align: text-top;
      width: 22px;
      height: 22px;
      background: #efefef;
      transition: background .2s;
    }

    // Box hover
    &:hover + label:before {
      background: #00ccca;
    }

    // Box focus
    &:focus + label:before {
      box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.12);
    }

    // Box checked
    &:checked + label:before {
      background: #00ccca;
    }

    // Disabled state label.
    &:disabled + label {
      color: #b8b8b8;
      cursor: auto;
    }

    // Disabled box.
    &:disabled + label:before {
      box-shadow: none;
      background: #ddd;
    }

    // Checkmark. Could be replaced with an image
    &:checked + label:after {
      content: '';
      position: absolute;
      left: 7px;
      top: 1px;
      border-bottom: 3px solid white;
      border-right: 3px solid white;
      width: 5px;
      height: 13px;
      transform: rotate(40deg);
    }
  }
</style>
